import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import useFilterStore from "@/stores/useFilterStore";
import { buildInitialFiltersFromSearch } from "@/utils/urlFilterParams";
import { toParams } from "@/utils/toParams";

import { oaBaseFilter, oaBaseTable } from "@/pages/Planning/OA/oa.constants";
import { OA_QUERY_FILTER_MAPPINGS } from "@/pages/Planning/OA/oa-query-schema";

export default function useOAListQueryFilters(tableOverrides = {}) {
	const location = useLocation();
	const filter = useFilterStore((state) => state.filter);
	const { estate_parent_id, estate_id, search, parameter } = filter;

	const appliedFilterParams = useMemo(() => {
		const { filters } = buildInitialFiltersFromSearch(oaBaseFilter, location.search, OA_QUERY_FILTER_MAPPINGS);
		return toParams(filters);
	}, [location.search]);

	return useMemo(
		() => ({
			...appliedFilterParams,
			page: tableOverrides.page || oaBaseTable.page,
			per_page: tableOverrides.per_page || oaBaseTable.per_page,
			estate_parent_id,
			estate_id,
			search,
			parameter,
		}),
		[appliedFilterParams, estate_parent_id, estate_id, search, parameter, tableOverrides.page, tableOverrides.per_page],
	);
}
